import AppleAppDownload from '../../../../assets/images/alertMessage/appleAppDownload.svg?react';
import GoogleAppDownload from '../../../../assets/images/alertMessage/googleAppDownload.svg?react';

export type getMobileAppUrlProps = {
  id: string;
  title: string;
  url: string;
  img: React.ReactNode;
};

export const getMobileAppUrlConfig = (): getMobileAppUrlProps[] => {
  return [
    {
      id: 'apple-download-app',
      title: 'apple',
      url: 'https://apps.apple.com/app/onstar-fleet-driver/id6809909687',
      img: <AppleAppDownload height={40} width={130} />,
    },
    {
      id: 'google-download-app',
      title: 'google',
      url: 'https://play.google.com/store/apps/details?id=com.gm.envolve.driver',
      img: <GoogleAppDownload height={39} width={130} />,
    },
  ];
};
